import React from 'react';

/**
 * Bloc JSON-LD générique. Le rendu traverse le SSR comme tout le reste : le
 * crawler le lit sans exécuter de JavaScript (plan §13 Phase 3).
 */
const JsonLd = ({ data }) => {
  if (!data) return null;
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }} />;
};

export default JsonLd;
